import "./Toast.scss"

import { ToastContainer as Container, ToastContainerProps } from "react-toastify"

export const ToastContainer = (props: ToastContainerProps) => <Container {...props} />
